import {
  RenewalBaseFragment,
  RenewalWithAgencyDataFragment,
  RenewalWithCheckReceivalFragment,
} from "@covertree/agent-portal-graphql";

export function mapUWReviewToDescription(
  renewal?:
    | RenewalBaseFragment
    | RenewalWithAgencyDataFragment
    | RenewalWithCheckReceivalFragment
) {
  const items: string[] = [];
  if (!renewal) return items;
  if (renewal?.description) {
    items.push(renewal.description);
  }
  if (
    renewal.underwritingReviewReasons &&
    renewal.underwritingReviewReasons.length > 0 &&
    !(
      renewal.underwritingReviewReasons.length === 1 &&
      renewal.underwritingReviewReasons[0] === "Accepted"
    )
  ) {
    items.push(
      ...(renewal.underwritingReviewReasons.filter(Boolean) as string[])
    );
  }
  return items;
}
